import { ReactElement } from "react";

export default function PinPoint(): ReactElement {
  return (
    <div className="pointContainer">
      <div className="pinpoint"></div>
    </div>
  );
}
